import GetPropertyExplorerNavTabs from '/src/services/Content/GetPropertyExplorerNavTabs';

export default function GetPlatformGoals(type = 'regular') {
    const navTabs = GetPropertyExplorerNavTabs();

    const goalItems = [
        {
            header: "What You're Up Against",
            text: "Understand the climate risks that matter most at your address—like flood, wildfire, heat, or storm exposure—and see how they directly affect your insurance, maintenance, and resale value.",
            image: "quoll-what-you-are-up-against.webp",
            description: "See the key climate risks in your area and the specific ones to focus on for your home. Understand how those risks will translate info financial cost, including how you budget, recurring expenses like insurance, maintenance, etc, and the long-term value of your home.",
            tabInfo: navTabs[1],
            productImages: [
                {
                    image: "quoll-product-risks-in-your-area.webp",
                    alt: "Risks in Your Area",
                    description: "Get a baseline of the regional hazards that may affect your home."
                },
                {
                    image: "quoll-product-risks-to-focus-on.webp",
                    alt: "Risks to Focus On",
                    description: "Identify which specific risks matter most for your property."
                },
                {
                    image: "quoll-product-risks-mapped-to-house.webp",
                    alt: "Risks Mapped to Your Home",
                    description: "See which parts of your home are most exposed."
                },
                {
                    image: "quoll-product-risks-financial-impact.webp",
                    alt: "Financial Impact of Risks",
                    description: "Estimate how each risk could affect short-term costs, recurring expenses, and long-term value."
                }
            ]
        },
        {
            header: "What You Can Do",
            text: "Explore targeted home adaptation projects that reduce damage, lower insurance costs, and protect your home’s long-term value.",
            description: "See the key climate risks in your area and the specific ones to focus on for your home. Understand how those risks will translate info financial cost, including how you budget, recurring expenses like insurance, maintenance, etc, and the long-term value of your home.",
            image: "quoll-what-you-can-do-about-it.webp",
            tabInfo: navTabs[2],
            productImages: [
                {
                    image: "quoll-product-projects-categorized.webp",
                    alt: "Project Categories",
                    description: "Explore projects organized by risk type (wind, flood, heat, etc.)."
                },
                {
                    image: "quoll-product-project-view.webp",
                    alt: "Project Breakdown",
                    description: "See cost, complexity, and expected benefits for each."
                },
                {
                    image: "quoll-product-projects-value.webp",
                    alt: "Compare Projects",
                    description: "Compare based on savings, ROI, or level of protection."
                },
                {
                    image: "quoll-product-project-combinations.webp",
                    alt: "Project Combinations",
                    description: "Model how projects work together to lower overall risk."
                },
                
            ]
        },
        {
            header: "How to Get It Done",
            text: "Utilize step-by-step guidance and tools to choose the right resilience improvements and start seeing financial and risk-reduction benefits.",
            description: "See the key climate risks in your area and the specific ones to focus on for your home. Understand how those risks will translate info financial cost, including how you budget, recurring expenses like insurance, maintenance, etc, and the long-term value of your home.",
            image: "quoll-how-to-get-it-done.webp",
            tabInfo: navTabs[3],
            productImages: [
                {
                    image: "quoll-product-taking-action-create-plan.webp",
                    alt: "Create a Plan",
                    description: "Build your own resilience roadmap."
                },
                {
                    image: "quoll-product-taking-action-get-discounts.webp",
                    alt: "Get Discounts",
                    description: "Access available incentives or rebates."
                },
                {
                    image: "quoll-product-taking-action-diy-help.webp",
                    alt: "DIY Help",
                    description: "Learn how to complete simple projects yourself."
                },
                {
                    image: "quoll-product-taking-action-connect-with-professionals.webp",
                    alt: "Professional Help",
                    description: "Connect with vetted experts for complex jobs."
                },
                {
                    image: "quoll-product-taking-action-quoll-to-market-for-you.webp",
                    alt: "Let Quoll Manage It",
                    description: "Prefer a hands-off approach? Let us help coordinate the process."
                }
            ]
        }
    ]

    if (type === 'extended') {
        goalItems.push({
            header: "Personalize Your Analysis",
            text: "Change details about the home or your preferences and watch the intelligence update. Don't worry, data is never shared.",
            description: "See the key climate risks in your area and the specific ones to focus on for your home. Understand how those risks will translate info financial cost, including how you budget, recurring expenses like insurance, maintenance, etc, and the long-term value of your home.",
            image: "quoll-what-you-are-up-against.webp",
            tabInfo: navTabs[4],
            productImages: [
                {
                    image: "quoll-product-personalize-about-me.webp",
                    alt: "Tailor the Insights to You",
                    description: "Adjust assumptions for a clearer future outlook."
                },
                {
                    image: "quoll-product-personalize-about-property.webp",
                    alt: "Add More Details",
                    description: "Refine your analysis with home-specific data for even greater accuracy."
                }
            ]
        })
    }

    return goalItems;
}